import React, { useCallback, useEffect, memo } from 'react';
import Particles from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import type { Container } from '@tsparticles/engine';
import { tsParticles } from '@tsparticles/engine';

interface TsParticlesProps {
  id?: string;
  className?: string;
  particleCount?: number;
  speed?: number;
  linkDistance?: number;
  opacity?: number;
}

const TsParticles: React.FC<TsParticlesProps> = ({
  id = 'tsparticles',
  className = '',
  particleCount = 50,
  speed = 0.5,
  linkDistance = 150,
  opacity = 0.5
}) => {
  // Initialize tsParticles engine
  useEffect(() => {
    loadSlim(tsParticles);
  }, []);

  const particlesLoaded = useCallback(async (_container: Container | undefined) => {
    // Particles loaded successfully
  }, []);

  return (
    <Particles
      id={id}
      className={`absolute inset-0 pointer-events-none ${className}`}
      particlesLoaded={particlesLoaded}
      options={{
        background: {
          color: {
            value: 'transparent',
          },
        },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: false,
            },
            onHover: {
              enable: true,
              mode: 'grab',
            },
            resize: {
              enable: true,
            },
          },
          modes: {
            grab: {
              distance: linkDistance,
              links: {
                opacity: 0.5,
              },
            },
          },
        },
        particles: {
          color: {
            value: ['#60A5FA', '#3B82F6', '#1D4ED8', '#06B6D4', '#8B5CF6'],
          },
          links: {
            color: '#60A5FA',
            distance: linkDistance,
            enable: true,
            opacity: opacity * 0.4,
            width: 1,
          },
          move: {
            direction: 'none',
            enable: true,
            outModes: {
              default: 'bounce',
            },
            random: false,
            speed: speed,
            straight: false,
          },
          number: {
            density: {
              enable: true,
            },
            value: particleCount,
          },
          opacity: {
            value: opacity,
          },
          shape: {
            type: 'circle',
          },
          size: {
            value: { min: 1, max: 3 },
          },
        },
        detectRetina: true,
        fullScreen: {
          enable: false,
        },
        pauseOnBlur: true,
        pauseOnOutsideViewport: true,
      }}
    />
  );
};

// Memoize the component to prevent re-mounting on parent re-renders
export default memo(TsParticles);